<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="linkTo(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(cardContent.title) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <div v-if="cardTypeProps">
          <CRow
            class="mr-5 ml-5"
            v-for="(test, index) in cardContent.content.page"
            :key="index"
            style="margin-top: 5%"
          >
            <CCol>
              <CRow>
                <h2 :class="checkLangClass()">
                  {{
                    checkLanguageAndReturnUpperCase(
                      cardContent.content.page[index].title
                    )
                  }}
                </h2>
              </CRow>
              <div class="container-grey">
                <div v-for="(data, index) in test.paragraph" :key="index">
                  <CRow class="mb-5" style="display: flex; align-items: center">
                    <CCol
                      col="2"
                      style="display: flex; justify-content: flex-end"
                    >
                      <template v-if="data.line[0].class !== ''">
                        <div @click="playSound(soundOBJ[index])" class="audio">
                          <font-awesome-icon
                            icon="volume-up"
                            class="IconClose"
                          />
                        </div>
                      </template>
                    </CCol>
                    <template v-if="data.line[0].class !== ''">
                      <CCol col="10">
                        <h2 class="mb-0 fontChinese">
                          {{ checkLanguageAndText(data.line[0].text, 'main') }}
                        </h2>
                        <h6 class="mb-0">
                          {{ checkLanguageAndText(data.line[0].text, 'sub') }}
                        </h6>
                      </CCol>
                    </template>
                    <template v-else>
                      <CCol col="12">
                        <h2 class="mb-0 fontChinese">
                          {{ checkLanguageAndText(data.line[0].text, 'main') }}
                        </h2>
                        <h6 class="mb-0">
                          {{ checkLanguageAndText(data.line[0].text, 'sub') }}
                        </h6>
                      </CCol>
                    </template>
                  </CRow>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow
            align-vertical="center"
            align-horizontal="center"
            style="margin-bottom: 5%"
          >
            <CButton
              color="danger"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-3 pb-3"
              @click="linkTo(cardContent.navigate.previous.action, 0)"
              >PREV</CButton
            >
            <CButton
              color="success"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-3 pb-3"
              @click="linkTo(cardContent.navigate.next.action, 1)"
              >NEXT</CButton
            >
          </CRow>
        </div>

        <CRow v-else align-horizontal="center" align-vertical="center">
          <CCol
            class="text-left"
            xl="6"
            lg="6"
            md="6"
            sm="6"
            align-horizontal="center"
            align-vertical="center"
          >
            <img
              class="img-left"
              :src="baseUrl + cardContent.content.item[1].data"
              alt="img"
              :style="imgCheck()"
            />
          </CCol>
          <CCol xl="6" lg="6" md="6" sm="6">
            <div class="img-container">
              <CRow align-vertical="center" align-horizontal="center">
                <VocabAudio
                  :cardContent="cardContent"
                  :soundObject="soundObj"
                />
              </CRow>
              <hr class="ml-5 mr-5" />
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="pt-3"
              >
                <h5 v-if="lang == 'CN'">
                  ({{ findEng(cardContent.content.description) }})
                </h5>
                <h5 v-else :class="checkLangClass() + ' ' + 'fontsize'">
                  ({{ checkLanguage(cardContent.content.description) }})
                </h5>
              </CRow>
              <CCol>
                <CRow
                  align-vertical="center"
                  align-horizontal="center"
                  class="p-3"
                >
                  <h2 v-if="lang == 'CN'">
                    {{ findEng(cardContent.content.title) }}
                  </h2>
                  <h2 v-else :class="checkLangClass() + ' ' + 'fontsize'">
                    {{ checkLanguage(cardContent.content.title) }}
                  </h2>
                </CRow>
              </CCol>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import VocabAudio from './VocabAudio';
import '../../../assets/scss/_chineseIcon.scss';
import '../../../assets/scss/_chineseStyle.scss';
import {mapGetters} from 'vuex';

export default {
  components: {VocabAudio},
  name: 'CardContent',
  props: {cardContent: Object, cardTypeProps: Boolean, soundOBJ: Array},
  data() {
    return {
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      soundProps: '',
    };
  },

  computed: {
    ...mapGetters({
      getLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    cardTypeProps: function () {
      if (this.cardTypeProps == 'example') {
        this.cardType = false;
      }
    },
    cardContent: function () {
      let str = this.cardContent.codeTemplate.split('-');
      if (str[0] === 'CTA05') {
        this.soundObj = new Audio(
          this.baseUrl +
            this.cardContent.content.page[0].paragraph[0].line[0].class
        );
      } else {
        this.soundObj = new Audio(
          this.baseUrl + this.cardContent.content.item[0].data
        );
      }
    },
    getLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {
    let str = this.cardContent.codeTemplate.split('-');
    if (str[0] === 'CTA05') {
      this.soundObj = new Audio(
        this.baseUrl +
          this.cardContent.content.page[0].paragraph[0].line[0].class
      );
    } else {
      this.soundObj = new Audio(
        this.baseUrl + this.cardContent.content.item[0].data
      );
    }
  },

  beforeDestroy() {},
  methods: {
    findEng(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == 'EN') {
            return val[i].value;
          }
        }
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    playSound(sound) {
      let audio = sound;
      if (sound) {
        audio.pause();
        audio.play();
      }
    },
    imgCheck() {
      return 'width: 100%;';
    },
    checkLanguage(val, type) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    checkLanguageAndText(val, type) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          var data = val[i];
          if (data.key == this.lang) {
            let str = data.value.split('(');
            if (type == 'main') {
              return str[0];
            } else if (type == 'sub') {
              if (this.lang == 'CN') {
                return '';
              } else {
                return '(' + str[1];
              }
            }
          }
        }
      } else {
      }
    },
    checkLanguageAndReturnUpperCase(val) {
      for (let i = 0; i <= val.length; i++) {
        if (val[i].key == this.lang) {
          return val[i].value.toUpperCase();
        }
      }
    },
    linkTo(path, type) {
      let payload = {
        path: path,
        type: type,
      };
      if (this.soundOBJ) {
        for (let i = 0; i < this.soundOBJ.length; i++) {
          let audio = this.soundOBJ[i];
          audio.pause();
        }
      }
      this.soundObj.pause();
      let str = path.split('-');
      this.$store.commit('necessary/setCodePage', str[1]);
      //let body = "/" + str[0] + "/" + str[1];
      //this.$router.push(body);
      this.$emit('nextRoute', payload);
    },
  },
};
</script>

<style scoped>
.fontsize {
  font-size: 1.55rem !important;
}
.img-container {
  background-color: #f2f2f2;
  width: 100%;
  height: 100%;
  font-size: 80px;
  border-radius: 10px;
}
.container-grey {
  padding: 40px;
  border-radius: 25px;
  background-color: #dcdcdc;
  width: 100%;
}
.audio {
  cursor: pointer;
  width: 45px !important;
  height: 45px !important;
  background-color: #457ae6 !important;
  border-radius: 50% !important;
  padding: 20px !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .container-grey {
    width: 260px;
    padding-left: 50px;
    margin-left: -57px;
    padding-top: 20px;
    padding-bottom: 10px;
    padding-right: 5px;
  }
}
</style>
